var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06948 8.58146C5.51308 8.58146 4.97946 8.36043 4.58603 7.96699C4.19259 7.57356 3.97156 7.03994 3.97156 6.48354C3.97156 5.92714 4.19259 5.39353 4.58603 5.00009C4.97946 4.60665 5.51308 4.38562 6.06948 4.38562C6.62588 4.38562 7.15949 4.60665 7.55293 5.00009C7.94637 5.39353 8.1674 5.92714 8.1674 6.48354C8.1674 6.75904 8.11313 7.03185 8.0077 7.28638C7.90227 7.54091 7.74774 7.77218 7.55293 7.96699C7.35812 8.1618 7.12685 8.31633 6.87232 8.42176C6.61779 8.52719 6.34498 8.58146 6.06948 8.58146ZM6.06948 0.609375C4.51155 0.609375 3.01744 1.22826 1.91582 2.32988C0.814196 3.4315 0.195313 4.92562 0.195312 6.48354C0.195313 10.8892 6.06948 17.3927 6.06948 17.3927C6.06948 17.3927 11.9436 10.8892 11.9436 6.48354C11.9436 4.92562 11.3248 3.4315 10.2231 2.32988C9.12152 1.22826 7.6274 0.609375 6.06948 0.609375Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.fa2d7f22dae8a1ac0cb46ba3f5dcfd32.svg";
export { ForwardRef as ReactComponent };